import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgFor } from '@angular/common';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { FeedbackSectionService } from './feedback-section.service';

@Component({
  selector: 'app-feedback-section',
  standalone: true,
  imports: [NgFor, RevealOnScrollDirective],
  templateUrl: './feedback-section.component.html',
  styleUrl: './feedback-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackSectionComponent {
  get testimonials() {
    return this.feedbackService.testimonials;
  }

  constructor(private readonly feedbackService: FeedbackSectionService) {}
}
